

const storeRouter = [
    {
        path: '/selectStore',
        name: 'SelectStore',
        component: () =>
        import(/* webpackChunkName: "dev" */ '@/views/store/selectStore/index.vue'),
        meta: {
            title: '选择店铺',
            deepth: 1
        }
    },
    {
        path: '/disBindStore',
        name: 'DisBindStore',
        component: () =>
        import(/* webpackChunkName: "dev" */ '@/views/store/disBindStore/index.vue'),
        meta: {
            title: '店铺绑定',
            deepth: 1
        }
    },
    {
        path: '/createStore',
        name: 'CreateStore',
        component: () =>
        import(/* webpackChunkName: "dev" */ '@/views/store/createStore/index.vue'),
        meta: {
            title: '创建店铺',
            deepth: 1
        }
    },
    {
        path: '/editIcon',
        name: 'EditIcon',
        component: () =>
        import(/* webpackChunkName: "dev" */ '@/views/store/createStore/editIcon.vue'),
        meta: {
            title: '编辑图片',
            deepth: 2
        }
    },
    {
        path: '/autoCreateIcon',
        name: 'AutoCreateIcon',
        component: () =>
        import(/* webpackChunkName: "dev" */ '@/views/store/createStore/autoCreateIcon.vue'),
        meta: {
            title: '店铺图标',
            deepth: 2
        }
    },
    {
        path: '/joinStore',
        name: 'JoinStore',
        component: () =>
        import(/* webpackChunkName: "dev" */ '@/views/store/joinStore/index.vue'),
        meta: {
            title: '加入店铺',
            deepth: 2
        }
    }
]

export default storeRouter;